import React, { useState, useRef, useEffect } from 'react';
import api from '../services/api';

const SocialPremium = ({ clientId }) => {
  const [messages, setMessages] = useState([
    {
      sender: 'ai',
      text: "Bonjour ! Je suis votre conseiller expert en **réglementation sociale (BOSS & Urssaf)**. 👥\n\nPosez-moi vos questions sur la paie, les cotisations sociales, les primes exonérées (ex: PPV), le calcul des avantages en nature ou les frais professionnels. Je ferai une recherche en temps réel sur les textes officiels pour vous répondre en citant mes sources.",
      time: new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
    }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const feedEndRef = useRef(null);

  const formatText = (text) => {
    return text
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.*?)\*/g, '<em>$1</em>')
      .replace(/\[(.*?)\]\((https?:\/\/.*?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" style="color: #0F6E56; font-weight: 500; text-decoration: underline;">$1</a>')
      .replace(/\n/g, '<br/>');
  };

  const handleSend = async (e) => {
    e.preventDefault();
    if (!input.trim() || loading) return;

    const userMessage = {
      sender: 'user',
      text: input,
      time: new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
    };

    setMessages(prev => [...prev, userMessage]);
    const query = input;
    setInput('');
    setLoading(true);

    try {
      const res = await api.post('/social/boss/chat', { message: query });
      if (res && res.reponse) {
        setMessages(prev => [...prev, {
          sender: 'ai',
          text: res.reponse,
          source: res.source,
          time: new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
        }]);
      } else {
        throw new Error('Réponse invalide');
      }
    } catch (err) {
      console.error('Erreur chat BOSS:', err);
      setMessages(prev => [...prev, {
        sender: 'ai',
        text: "Désolé, je rencontre un problème de connexion pour interroger le BOSS. Veuillez réessayer.",
        time: new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
      }]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (feedEndRef.current) {
      feedEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, loading]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#FAF9F5', borderRadius: '16px', border: '1px solid #E8E7E3', overflow: 'hidden' }}>
      
      {/* En-tête */}
      <div style={{ background: 'white', padding: '16px 24px', borderBottom: '1px solid #E8E7E3', display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span style={{ fontSize: '24px' }}>👥</span>
        <div>
          <h3 style={{ fontSize: '15px', fontWeight: '600', color: '#111827', margin: 0 }}>Consultant Réglementation Sociale (BOSS)</h3>
          <p style={{ fontSize: '12px', color: '#10B981', margin: '2px 0 0 0', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ width: '6px', height: '6px', background: '#10B981', borderRadius: '50%', display: 'inline-block' }} /> 
            Recherche en temps réel activée
          </p>
        </div>
      </div>

      {/* Flux de messages */}
      <div style={{ flex: 1, padding: '24px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {messages.map((m, idx) => (
          <div key={idx} style={{ 
            alignSelf: m.sender === 'user' ? 'flex-end' : 'flex-start',
            maxWidth: '75%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: m.sender === 'user' ? 'flex-end' : 'flex-start'
          }}>
            <div style={{
              background: m.sender === 'user' ? '#0F6E56' : 'white',
              color: m.sender === 'user' ? 'white' : '#1F2937',
              padding: '12px 16px',
              borderRadius: m.sender === 'user' ? '12px 12px 0 12px' : '12px 12px 12px 0',
              fontSize: '13px',
              lineHeight: '1.5',
              boxShadow: m.sender === 'user' ? 'none' : '0 1px 3px rgba(0,0,0,0.05)',
              border: m.sender === 'user' ? 'none' : '1px solid #E5E7EB'
            }}>
              <div dangerouslySetInnerHTML={{ __html: formatText(m.text) }} />
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px', fontSize: '11px', color: '#9CA3AF' }}>
              <span>{m.time}</span>
              {m.source && (
                <span style={{ background: '#E1F5EE', color: '#0F6E56', padding: '1px 6px', borderRadius: '10px', fontWeight: '500' }}>
                  Source: {m.source}
                </span>
              )}
            </div>
          </div>
        ))}
        
        {loading && (
          <div style={{ alignSelf: 'flex-start', background: 'white', border: '1px solid #E5E7EB', padding: '12px 16px', borderRadius: '12px 12px 12px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ width: '6px', height: '6px', background: '#9CA3AF', borderRadius: '50%', animation: 'bounce 1.4s infinite ease-in-out' }} />
            <div style={{ width: '6px', height: '6px', background: '#9CA3AF', borderRadius: '50%', animation: 'bounce 1.4s infinite ease-in-out 0.2s' }} />
            <div style={{ width: '6px', height: '6px', background: '#9CA3AF', borderRadius: '50%', animation: 'bounce 1.4s infinite ease-in-out 0.4s' }} />
            <span style={{ fontSize: '12px', color: '#9CA3AF', marginLeft: '4px' }}>Recherche BOSS en cours...</span>
          </div>
        )}
        <div ref={feedEndRef} />
      </div>

      {/* Barre d'envoi */}
      <form onSubmit={handleSend} style={{ background: 'white', padding: '16px 24px', borderTop: '1px solid #E8E7E3', display: 'flex', gap: '12px' }}>
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ex: Quelles sont les conditions d'exonération de la prime de partage de la valeur (PPV) ?"
          disabled={loading}
          style={{
            flex: 1,
            padding: '10px 16px',
            borderRadius: '10px',
            border: '1px solid #D1D5DB',
            outline: 'none',
            fontSize: '13px',
            background: loading ? '#F3F4F6' : 'white'
          }}
        />
        <button
          type="submit"
          disabled={loading || !input.trim()}
          style={{
            background: '#0F6E56',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '10px',
            fontSize: '13px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
        >
          Poser la question ↗
        </button>
      </form>

      <style>{`
        @keyframes bounce {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1.0); }
        }
      `}</style>
    </div>
  );
};

export default SocialPremium;
